import api from '../../interceptorServices';
import base_url from '../../../config';
const path = base_url+'api/event/accommodation';
const paymentUrl = base_url+'api/event/paymentReceipt';
const accommodationSetupUrl = base_url+'api/management/accommodationSetup';

export const getData = async (params) => {
  const whereParam = params;
  const response = await api.post(path, whereParam);
  return response.data.data;
};

export const getDataById = async (data) => {
  const response = await api.post(path, data);
  return response.data;
};

export const addData = async (data) => {
  const response = await api.post(path, data);
  return response.data;
};

export const updateData = async (data) => {
  const response = await api.put(path, data);
  return response.data;
};

export const deleteData = async (data) => {
  const response = await api.delete(path, {
    data: { id: data.id },
  });
  return response.data;
};

export const getaccommodationSetup = async (params) => {
  const whereParam = params;
  const response = await api.post(accommodationSetupUrl, whereParam);
  return response.data.data;
};

export const getpayment = async (params) => {
  try {
    const response = await api.post(paymentUrl, params);  // Pass params directly
    return response.data.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};
